"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recoverStateOnChangeNestedValue = exports.syncStateOnCallbackNativeValue = exports.syncStateOnCallbackValue = exports.syncStateOnPropsValue = void 0;
const nativeValue_1 = require("./nativeValue");
const syncStateOnPropsValue = (state, value, type) => {
    const isMemoizedValue = [state.propsValue, state.callbackValue].includes(value);
    state.propsValue = value;
    if (isMemoizedValue) {
        if (state.nativeValue === undefined) {
            state.nativeValue = (0, nativeValue_1.toNativeValue)(value, type);
        }
        return;
    }
    // change nativeValue on new value
    state.nativeValue = (0, nativeValue_1.toNativeValue)(value, type);
    state.nativeError = undefined;
    state.error = undefined;
};
exports.syncStateOnPropsValue = syncStateOnPropsValue;
const syncStateOnCallbackValue = (state, value, type) => {
    state.callbackValue = value;
    state.nativeValue = (0, nativeValue_1.toNativeValue)(value, type);
    state.nativeError = undefined;
    state.error = undefined;
};
exports.syncStateOnCallbackValue = syncStateOnCallbackValue;
const syncStateOnCallbackNativeValue = (state, nativeValue, type, formatMessage) => {
    state.nativeValue = nativeValue;
    const { value, nativeError } = (0, nativeValue_1.toValue)(nativeValue, type, formatMessage);
    state.callbackValue = value;
    state.nativeError = nativeError;
    state.error = undefined;
};
exports.syncStateOnCallbackNativeValue = syncStateOnCallbackNativeValue;
/** Recover state after rough nested cleaning */
const recoverStateOnChangeNestedValue = (state, value, type) => {
    state.callbackValue = value;
    state.nativeValue = (0, nativeValue_1.toNativeValue)(value, type);
};
exports.recoverStateOnChangeNestedValue = recoverStateOnChangeNestedValue;
//# sourceMappingURL=valueState.js.map